<template>
  <v-tooltip top
             :color="color">
    <template v-slot:activator="{on, attrs}">
      <v-icon v-bind="attrs"
              v-on="on"
              :color="iconColor"
              small>
        {{ icon }}
      </v-icon>
    </template>
    <div :style="style">
      <slot></slot>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    position: {
      type: String,
      default: 'top',
    },
    iconColor: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'fas fa-fw fa-question-circle'
    },
    maxWidth: {
      type: String,
      default: '400px',
    }
  },
  computed: {
    style() {
      return `max-width: ${this.maxWidth};`
    }
  }
}
</script>
